import Vue from 'vue'
import { debounce, range } from 'lodash'
const searchSortByDefault = 'Email'

const user = {
  state: {
    users: [],
    selectedUser: {},
    searchTotal: 0,
    searchCount: 0,
    searchPage: 1,
    searchSortBy: searchSortByDefault,
    searchDescending: false,
    searchRowsPerPage: 25,
    searchText: '',
    lookupText: '',
    saving: false,
    agencySearchID: null,
    agencySearchRoles: null,
    searchShowInactive: false,
    searchAgencyId: [],
  },

  getters: {
    users (state) {
      return state.users
    },
    selectedUser (state) {
      return state.selectedUser
    },
    searchParameters (state) {
      return {
        pageNum: state.searchPage - 1,
        pageSize: state.searchRowsPerPage,
        sortProperty: state.searchSortBy,
        sortDirection: state.searchDescending ? 'desc' : 'asc',
        searchText: state.searchText,
        showInactive: state.searchShowInactive,
        agencyId: state.searchAgencyId,
      }
    },
    loading (state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    users (state, payload) {
      state.users = payload
    },
    selectedUser (state, payload) {
      state.selectedUser = JSON.parse(JSON.stringify(payload))
    },
    searchTotal (state, payload) {
      state.searchTotal = payload
    },
    searchCount (state, payload) {
      state.searchCount = payload
    },
    searchPage (state, payload) {
      state.searchPage = payload
    },
    searchSortBy (state, payload) {
      state.searchSortBy = payload
    },
    searchDescending (state, payload) {
      state.searchDescending = payload
    },
    searchRowsPerPage (state, payload) {
      state.searchRowsPerPage = payload
    },
    searchText (state, payload) {
      state.searchText = payload
    },
    increaseSearchCount (state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount (state, payload) {
      state.searchCount = state.searchCount - 1
    },
    lookupText (state, payload) {
      state.lookupText = payload
    },
    saving (state, payload) {
      state.saving = payload
    },
    searchShowInactive (state, payload) {
      state.searchShowInactive = payload
    },
    agencySearchID (state, payload) {
      state.agencySearchID = payload
    },
    searchAgencyId (state, payload) {
      state.searchAgencyId = payload
    },
    agencySearchRoles (state, payload) {
      state.agencySearchRoles = payload
    },
  },

  actions: {
    lookupBounce: _.debounce((context) => {
      context.dispatch('lookupUsers')
    }, 300),
    bounce: _.debounce((context) => {
      context.dispatch('searchUsers')
    }, 750),
    setSearchPage (context, payload) {
      if (payload != context.state.searchPage) {
        context.commit('searchPage', payload)
        context.dispatch('bounce', context)
      }
    },
    setSearchSortBy (context, payload) {
      if (payload != context.state.searchSortBy) {
        context.commit('searchSortBy', payload)
        context.dispatch('bounce', context)
      }
    },
    setSearchDescending (context, payload) {
      if (payload != context.state.searchDescending) {
        context.commit('searchDescending', payload)
        context.dispatch('bounce', context)
      }
    },
    setSearchRowsPerPage (context, payload) {
      if (payload != context.state.searchRowsPerPage) {
        context.commit('searchRowsPerPage', payload)
        context.dispatch('bounce', context)
      }
    },
    setSearchText (context, payload) {
      if (payload != context.state.searchText) {
        context.commit('searchText', payload)
        context.dispatch('bounce', context)
      }
    },
    setLookupText (context, payload) {
      if (payload != context.state.lookupText && payload != null) {
        context.commit('lookupText', payload)
        context.commit('users', [])
        context.dispatch('lookupBounce', context)
      }
    },
    setSearchShowInactive (context, payload) {
      if (payload != context.state.searchShowInactive) {
        context.commit('searchShowInactive', payload)
        context.dispatch('bounce', context)
      }
    },
    setSearchAgencyId (context, payload) {
      if (payload != context.state.searchAgencyId) {
        context.commit('searchAgencyId', payload)
        context.dispatch('bounce', context)
      }
    },
    setSelectedUser (context, payload) {
      context.commit('selectedUser', payload)
    },
    loadUsers (context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'User'
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('users', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    loadAgencyUsers (context, payload) {
      return new Promise((resolve, reject) => {
        const url = `User/Agency/${payload}`
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('users', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    refreshSelectedUser (context, payload) {
      if (context.state.selectedUser && context.state.selectedUser.ID > 0) {
        context.dispatch('loadSelectedUser', context.state.selectedUser.ID)
      }
    },
    loadSelectedUser (context, payload) {
      if (
        context.state.selectedUser &&
        context.state.selectedUser.ID != payload
      ) {
        context.commit('selectedUser', {})
      }
      return new Promise((resolve, reject) => {
        const url = 'User/' + payload
        context.commit('increaseSearchCount')
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedUser', res.data)
            context.commit('decreaseSearchCount')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('decreaseSearchCount')
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    searchUsers (context, payload) {
      return new Promise((resolve, reject) => {
        if (!context.state.searchSortBy) {
          context.commit('searchSortBy', searchSortByDefault)
          context.commit('searchDescending', true)
        }
        if (Array.isArray(context.state.searchSortBy)) {
          if (context.state.searchSortBy.length > 0) {
            context.commit('searchSortBy', context.state.searchSortBy[0])
            context.commit(
              'searchDescending',
              context.state.searchDescending[0]
            )
          } else {
            context.commit('searchSortBy', searchSortByDefault)
            context.commit('searchDescending', true)
          }
        }
        if (!context.state.searchText) {
          context.commit('searchText', '')
        }
        context.commit('increaseSearchCount')
        var params = context.getters.searchParameters
        var paramString = JSON.stringify(params)
        const url = `User/Search`
        if (
          context.rootGetters['auth/isSuperUser'] ||
          params.agencyId.length == 1
        ) {
          Vue.prototype.$axios.post(url, params).then(
            (res) => {
              if (
                JSON.stringify(context.getters.searchParameters) == paramString
              ) {
                context.commit('users', res.data.Entries)
                context.commit('searchRowsPerPage', res.data.Page.Size)
                context.commit('searchPage', res.data.Page.Number + 1)
                context.commit('searchTotal', res.data.Page.TotalElements)
              }
              context.commit('decreaseSearchCount')
              resolve(res)
            },
            (err) => {
              console.error(err)
              context.dispatch('errors/handleError', err, { root: true })
              context.commit('decreaseSearchCount')
              reject(err)
            }
          )
        } else {
          reject('invalid search params')
        }
      })
    },
    lookupUsers (context, payload) {
      if (context.state.lookupText) {
        return new Promise((resolve, reject) => {
          context.commit('increaseSearchCount')

          let url = `User/Lookup?searchText=${context.state.lookupText}`
          if (context.state.agencySearchID > 0) {
            var agencyRoles = context.state.agencySearchRoles || []
            url = `User/LookupByAgency?searchText=${context.state.lookupText}&agencyID=${context.state.agencySearchID}&agencyRoles=${agencyRoles}`
          }
          Vue.prototype.$axios.get(url).then(
            (res) => {
              context.commit('users', res.data)
              context.commit('decreaseSearchCount')
              resolve(res)
            },
            (err) => {
              console.error(err)
              context.dispatch('errors/handleError', err, { root: true })
              context.commit('decreaseSearchCount')
              reject(err)
            }
          )
        })
      }
    },
    clearLookupCacheAndReloadUsers (context, payload) {
      caches.delete('apilookup-cache').finally(() => {
        context.dispatch('loadUsers')
      })
    },
    updateUser (context, payload) {
      return new Promise((resolve, reject) => {
        const url = `User/${payload.ID}`
        context.commit('saving', true)
        Vue.prototype.$axios.put(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'user updated' },
              { root: true }
            )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadUsers')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    createUser (context, payload) {
      return new Promise((resolve, reject) => {
        const url = `User`
        context.commit('saving', true)
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'user created' },
              { root: true }
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadUsers')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    saveUser (context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateUser', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        } else {
          context.dispatch('createUser', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        }
      })
    },
    deleteUser (context, payload) {
      return new Promise((resolve, reject) => {
        const url = `User/${payload.ID}`
        Vue.prototype.$axios.delete(url).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'user deleted' },
              { root: true }
            )
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadUsers')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
  },
}

export default user
